import {
    Card,
    Colors,
    DATE_FORMATS,
    DateInput,
    Heading,
    Icon,
    type OptionProps,
    SelectOutlined,
    Text,
} from '@amelio/ui-library';

import { FormField } from '@/components/FormField/FormField';
import { Locale } from '@/constants/Locale';
import { useAmelioTranslations } from '@/hooks';
import i18n from '@/plugins/i18n';

interface Props {
    options?: OptionProps[];
    scheduledAt?: Date;
    feedbackFrequency?: string;
    onScheduledAtChange: (date: Date) => void;
    onFeedbackFrequencyChange?: (value: string) => void;
}

export const ScheduleFrequency = ({
    options,
    scheduledAt,
    feedbackFrequency,
    onScheduledAtChange,
    onFeedbackFrequencyChange,
}: Props) => {
    const { t } = useAmelioTranslations();

    return (
        <div className={'relative z-30'}>
            <Card
                className={'mt-5 overflow-visible'}
                bgColor={'bg-white'}
                borderRadius={'2xl'}
            >
                <div className={'flex items-center'}>
                    <Icon
                        name={'edit-menu-board'}
                        size={'xl'}
                        className={'mr-3'}
                    />

                    <Heading level={5}>
                        {t('evaluation360ScheduleCreation.scheduleOptions.title')}
                    </Heading>
                </div>

                <Text
                    className={'mt-1'}
                    color={Colors.BASE_400}
                    weight={'medium'}
                    size={'small'}
                >
                    {t('cycleEvaluationSchedule.schedulingOptions.subtitle')}
                </Text>

                <div className={'z-50 mt-5 flex flex-col gap-5 md:flex-row md:gap-10'}>
                    <FormField
                        label={t('cycleEvaluationSchedule.schedulingOptions.scheduledAt')}
                        className={'z-50 w-full md:!w-80'}
                    >
                        <div className={'relative z-50'}>
                            <DateInput
                                placeholder={t('common.selectDate')}
                                onChange={(value) => onScheduledAtChange(value ?? new Date())}
                                value={scheduledAt}
                                lang={i18n.language === Locale.EN ? 'en' : 'fr'}
                                dateFormat={DATE_FORMATS.DISPLAY_DATE_TIME}
                                showTime
                                disabledDates={{
                                    before: new Date(),
                                }}
                                clearable={false}
                            />
                        </div>
                    </FormField>

                    <FormField
                        label={t('cycleEvaluationSchedule.schedulingOptions.feedbackFrequency')}
                        className={'w-full md:!w-80'}
                    >
                        <SelectOutlined
                            options={options || []}
                            value={feedbackFrequency}
                            onChange={onFeedbackFrequencyChange}
                            sort={'none'}
                        />
                    </FormField>
                </div>
            </Card>
        </div>
    );
};
